import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.define-property";
import { __extends } from "tslib";
import { NodeMaterialBlock } from '../../nodeMaterialBlock';
import { NodeMaterialBlockTargets } from '../../Enums/nodeMaterialBlockTargets';
import { NodeMaterialBlockConnectionPointTypes } from '../../Enums/nodeMaterialBlockConnectionPointTypes';
import { MaterialHelper } from '../../../materialHelper';
import { NodeMaterialSystemValues } from '../../Enums/nodeMaterialSystemValues';
import { InputBlock } from '../Input/inputBlock';
import { _TypeStore } from '../../../../Misc/typeStore';
import "../../../../Shaders/ShadersInclude/lightFragmentDeclaration";
import "../../../../Shaders/ShadersInclude/lightUboDeclaration";
import "../../../../Shaders/ShadersInclude/lightFragment";
import "../../../../Shaders/ShadersInclude/helperFunctions";
import "../../../../Shaders/ShadersInclude/lightsFragmentFunctions";
import "../../../../Shaders/ShadersInclude/shadowsFragmentFunctions";
import "../../../../Shaders/ShadersInclude/shadowsVertex";
/**
 * Block used to add light in the fragment shader
 */

var LightBlock =
/** @class */
function (_super) {
  __extends(LightBlock, _super);
  /**
   * Create a new LightBlock
   * @param name defines the block name
   */


  function LightBlock(name) {
    var _this = _super.call(this, name, NodeMaterialBlockTargets.VertexAndFragment) || this;

    _this._isUnique = true;

    _this.registerInput("worldPosition", NodeMaterialBlockConnectionPointTypes.Vector4, false, NodeMaterialBlockTargets.Vertex);

    _this.registerInput("worldNormal", NodeMaterialBlockConnectionPointTypes.Vector4, false, NodeMaterialBlockTargets.Fragment);

    _this.registerInput("cameraPosition", NodeMaterialBlockConnectionPointTypes.Vector3, false, NodeMaterialBlockTargets.Fragment);

    _this.registerInput("glossiness", NodeMaterialBlockConnectionPointTypes.Float, true, NodeMaterialBlockTargets.Fragment);

    _this.registerInput("glossPower", NodeMaterialBlockConnectionPointTypes.Float, true, NodeMaterialBlockTargets.Fragment);

    _this.registerInput("diffuseColor", NodeMaterialBlockConnectionPointTypes.Color3, true, NodeMaterialBlockTargets.Fragment);

    _this.registerInput("specularColor", NodeMaterialBlockConnectionPointTypes.Color3, true, NodeMaterialBlockTargets.Fragment);

    _this.registerOutput("diffuseOutput", NodeMaterialBlockConnectionPointTypes.Color3, NodeMaterialBlockTargets.Fragment);

    _this.registerOutput("specularOutput", NodeMaterialBlockConnectionPointTypes.Color3, NodeMaterialBlockTargets.Fragment);

    _this.registerOutput("shadow", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Fragment);

    return _this;
  }
  /**
   * Gets the current class name
   * @returns the class name
   */


  LightBlock.prototype.getClassName = function () {
    return "LightBlock";
  };

  Object.defineProperty(LightBlock.prototype, "worldPosition", {
    /**
     * Gets the world position input component
     */
    get: function get() {
      return this._inputs[0];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "worldNormal", {
    /**
     * Gets the world normal input component
     */
    get: function get() {
      return this._inputs[1];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "cameraPosition", {
    /**
    * Gets the camera (or eye) position component
    */
    get: function get() {
      return this._inputs[2];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "glossiness", {
    /**
    * Gets the glossiness component
    */
    get: function get() {
      return this._inputs[3];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "glossPower", {
    /**
    * Gets the glossinness power component
    */
    get: function get() {
      return this._inputs[4];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "diffuseColor", {
    /**
    * Gets the diffuse color component
    */
    get: function get() {
      return this._inputs[5];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "specularColor", {
    /**
    * Gets the specular color component
    */
    get: function get() {
      return this._inputs[6];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "diffuseOutput", {
    /**
     * Gets the diffuse output component
     */
    get: function get() {
      return this._outputs[0];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "specularOutput", {
    /**
     * Gets the specular output component
     */
    get: function get() {
      return this._outputs[1];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LightBlock.prototype, "shadow", {
    /**
     * Gets the shadow output component
     */
    get: function get() {
      return this._outputs[2];
    },
    enumerable: true,
    configurable: true
  });

  LightBlock.prototype.autoConfigure = function (material) {
    if (!this.cameraPosition.isConnected) {
      var cameraPositionInput = material.getInputBlockByPredicate(function (b) {
        return b.systemValue === NodeMaterialSystemValues.CameraPosition;
      });

      if (!cameraPositionInput) {
        cameraPositionInput = new InputBlock("cameraPosition");
        cameraPositionInput.setAsSystemValue(NodeMaterialSystemValues.CameraPosition);
      }

      cameraPositionInput.output.connectTo(this.cameraPosition);
    }
  };

  LightBlock.prototype.prepareDefines = function (mesh, nodeMaterial, defines) {
    if (!defines._areLightsDirty) {
      return;
    }

    var scene = mesh.getScene();

    if (!this.light) {
      MaterialHelper.PrepareDefinesForLights(scene, mesh, defines, true, nodeMaterial.maxSimultaneousLights);
    } else {
      var state = {
        needNormals: false,
        needRebuild: false,
        lightmapMode: false,
        shadowEnabled: false,
        specularEnabled: false
      };
      MaterialHelper.PrepareDefinesForLight(scene, mesh, this.light, this._lightId, defines, true, state);

      if (state.needRebuild) {
        defines.rebuild();
      }
    }
  };

  LightBlock.prototype.updateUniformsAndSamples = function (state, nodeMaterial, defines, uniformBuffers) {
    for (var lightIndex = 0; lightIndex < nodeMaterial.maxSimultaneousLights; lightIndex++) {
      if (!defines["LIGHT" + lightIndex]) {
        break;
      }

      MaterialHelper.PrepareUniformsAndSamplersForLight(lightIndex, state.uniforms, state.samplers, defines["PROJECTEDLIGHTTEXTURE" + lightIndex], uniformBuffers);
    }
  };

  LightBlock.prototype.bind = function (effect, nodeMaterial, mesh) {
    if (!mesh) {
      return;
    }

    var scene = mesh.getScene();

    if (!this.light) {
      MaterialHelper.BindLights(scene, mesh, effect, true, nodeMaterial.maxSimultaneousLights);
    } else {
      MaterialHelper.BindLight(this.light, this._lightId, scene, effect, true);
    }
  };

  LightBlock.prototype._injectVertexCode = function (state) {
    var worldPos = this.worldPosition;
    var comments = "//" + this.name; // Declaration

    if (!this.light) {
      // Emit for all lights
      state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
        repeatKey: "maxSimultaneousLights"
      });

      this._lightId = 0;
      state.sharedData.dynamicUniformBlocks.push(this);
    } else {
      this._lightId = (state.counters["lightCounter"] !== undefined ? state.counters["lightCounter"] : -1) + 1;
      state.counters["lightCounter"] = this._lightId;

      state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
        replaceStrings: [{
          search: /{X}/g,
          replace: this._lightId.toString()
        }]
      }, this._lightId.toString());
    } // Inject code in vertex


    var worldPosVaryingName = "v_" + worldPos.associatedVariableName;

    if (state._emitVaryingFromString(worldPosVaryingName, "vec4")) {
      state.compilationString += worldPosVaryingName + " = " + worldPos.associatedVariableName + ";\r\n";
    }

    if (this.light) {
      state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
        replaceStrings: [{
          search: /{X}/g,
          replace: this._lightId.toString()
        }, {
          search: /worldPos/g,
          replace: worldPos.associatedVariableName
        }]
      });
    } else {
      state.compilationString += "vec4 worldPos = " + worldPos.associatedVariableName + ";\r\n";
      state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
        repeatKey: "maxSimultaneousLights"
      });
    }
  };

  LightBlock.prototype._buildBlock = function (state) {
    _super.prototype._buildBlock.call(this, state);

    if (state.target !== NodeMaterialBlockTargets.Fragment) {
      // Vertex
      this._injectVertexCode(state);

      return;
    } // Fragment


    state.sharedData.bindableBlocks.push(this);
    state.sharedData.blocksWithDefines.push(this);
    var comments = "//" + this.name;
    var worldPos = this.worldPosition;

    state._emitFunctionFromInclude("helperFunctions", comments);

    state._emitFunctionFromInclude("lightsFragmentFunctions", comments, {
      replaceStrings: [{
        search: /vPositionW/g,
        replace: "v_" + worldPos.associatedVariableName + ".xyz"
      }]
    });

    state._emitFunctionFromInclude("shadowsFragmentFunctions", comments, {
      replaceStrings: [{
        search: /vPositionW/g,
        replace: "v_" + worldPos.associatedVariableName + ".xyz"
      }]
    });

    if (!this.light) {
      // Emit for all lights
      state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
        repeatKey: "maxSimultaneousLights"
      });
    } else {
      state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
        replaceStrings: [{
          search: /{X}/g,
          replace: this._lightId.toString()
        }]
      }, this._lightId.toString());
    } // Code


    if (this._lightId === 0) {
      if (state._registerTempVariable("viewDirectionW")) {
        state.compilationString += "vec3 viewDirectionW = normalize(" + this.cameraPosition.associatedVariableName + " - " + ("v_" + worldPos.associatedVariableName) + ".xyz);\r\n";
      }

      state.compilationString += "lightingInfo info;\r\n";
      state.compilationString += "float shadow = 1.;\r\n";
      state.compilationString += "float glossiness = " + (this.glossiness.isConnected ? this.glossiness.associatedVariableName : "1.0") + " * " + (this.glossPower.isConnected ? this.glossPower.associatedVariableName : "1024.0") + ";\r\n";
      state.compilationString += "vec3 diffuseBase = vec3(0., 0., 0.);\r\n";
      state.compilationString += "vec3 specularBase = vec3(0., 0., 0.);\r\n";
      state.compilationString += "vec3 normalW = " + this.worldNormal.associatedVariableName + ".xyz;\r\n";
    }

    if (this.light) {
      state.compilationString += state._emitCodeFromInclude("lightFragment", comments, {
        replaceStrings: [{
          search: /{X}/g,
          replace: this._lightId.toString()
        }]
      });
    } else {
      state.compilationString += state._emitCodeFromInclude("lightFragment", comments, {
        repeatKey: "maxSimultaneousLights"
      });
    }

    var diffuseOutput = this.diffuseOutput;
    var specularOutput = this.specularOutput;
    state.compilationString += this._declareOutput(diffuseOutput, state) + (" = diffuseBase" + (this.diffuseColor.isConnected ? " * " + this.diffuseColor.associatedVariableName : "") + ";\r\n");

    if (specularOutput.hasEndpoints) {
      state.compilationString += this._declareOutput(specularOutput, state) + (" = specularBase" + (this.specularColor.isConnected ? " * " + this.specularColor.associatedVariableName : "") + ";\r\n");
    }

    if (this.shadow.hasEndpoints) {
      state.compilationString += this._declareOutput(this.shadow, state) + " = shadow;\r\n";
    }

    return this;
  };

  LightBlock.prototype.serialize = function () {
    var serializationObject = _super.prototype.serialize.call(this);

    if (this.light) {
      serializationObject.lightId = this.light.id;
    }

    return serializationObject;
  };

  LightBlock.prototype._deserialize = function (serializationObject, scene, rootUrl) {
    _super.prototype._deserialize.call(this, serializationObject, scene, rootUrl);

    if (serializationObject.lightId) {
      this.light = scene.getLightByID(serializationObject.lightId);
    }
  };

  return LightBlock;
}(NodeMaterialBlock);

export { LightBlock };
_TypeStore.RegisteredTypes["BABYLON.LightBlock"] = LightBlock;